var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',[_c('el-header',[_c('p',{staticClass:"bigTitle"},[_vm._v("预警监控")])]),_c('el-main',[_vm._v("Main")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }